// LanguageSwitch.js
import React from 'react';
import '../VoiceAssistant.css'; // usa los estilos de los switches

const LanguageSwitch = ({ label, lang, onToggle }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <span><strong>{label}</strong></span>
      <label className="switch">
        <input
          type="checkbox"
          checked={lang === 'es-US'}
          onChange={onToggle}
        />
        <span className="slider"></span>
      </label>
      <span>{lang === 'en-US' ? 'English' : 'Español'}</span>
    </div>
  );
};

export default LanguageSwitch;
